module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1dc60808!./packages/dof-searchbar/diablo.css
// module id = 434
// module chunks = 0 1